import { useLocation, useNavigate } from "react-router";
import { adminPath, hubPath, refresh } from "./current";

// next/navigation for the copied dashboard screens: the same calls, on the hub's router.

export function usePathname() {
  return adminPath(useLocation().pathname);
}

export function useRouter() {
  const navigate = useNavigate();
  return {
    push: (href: string) => navigate(hubPath(href)),
    replace: (href: string, _options?: { scroll?: boolean }) => navigate(hubPath(href), { replace: true, preventScrollReset: _options?.scroll === false }),
    refresh,
  };
}
